import React, { useState, useEffect } from 'react';
import { Menu, Bell, Search, X } from 'lucide-react';
import { Input } from '../ui/input';

export const DispatcherHeader = ({ onMenuClick, title }) => {
  const [showSearch, setShowSearch] = useState(false);
  const [notifications] = useState(3);
  const [dispatcherInfo, setDispatcherInfo] = useState({
    firstName: 'Dispatcher',
    lastName: '',
    email: 'dispatcher@tiataxi.al'
  });

  useEffect(() => {
    // Get dispatcher's own info from localStorage
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (user?.name) {
      const nameParts = user.name.split(' ');
      setDispatcherInfo({
        firstName: nameParts[0] || 'Dispatcher',
        lastName: nameParts.slice(1).join(' ') || '',
        email: user.email || 'dispatcher@tiataxi.al'
      });
    }
    
    // Listen for user updates (when name is changed in settings)
    const handleUserUpdate = () => {
      const updatedUser = JSON.parse(localStorage.getItem('user') || '{}');
      if (updatedUser?.name) {
        const nameParts = updatedUser.name.split(' ');
        setDispatcherInfo({
          firstName: nameParts[0] || 'Dispatcher',
          lastName: nameParts.slice(1).join(' ') || '',
          email: updatedUser.email || 'dispatcher@tiataxi.al'
        });
      }
    };
    
    window.addEventListener('userUpdated', handleUserUpdate);
    return () => window.removeEventListener('userUpdated', handleUserUpdate);
  }, []);

  // Get initials
  const getInitials = () => {
    const first = dispatcherInfo.firstName?.charAt(0) || 'D';
    const last = dispatcherInfo.lastName?.charAt(0) || '';
    return (first + last).toUpperCase() || 'D';
  };

  // Get display name
  const getDisplayName = () => {
    if (dispatcherInfo.lastName) {
      return `${dispatcherInfo.firstName} ${dispatcherInfo.lastName}`;
    }
    return dispatcherInfo.firstName || 'Dispatcher';
  };

  return (
    <header className="h-16 bg-white border-b border-gray-100 flex items-center justify-between px-6 sticky top-0 z-30">
      <div className="flex items-center gap-4">
        <button 
          className="lg:hidden p-2 hover:bg-gray-100 rounded-lg"
          onClick={onMenuClick}
        >
          <Menu className="w-5 h-5" />
        </button>
        <h1 className="text-xl font-semibold" style={{ color: 'var(--text-primary)' }}>
          {title || 'Dashboard'}
        </h1>
      </div>

      <div className="flex items-center gap-3">
        {/* Search */}
        {showSearch ? (
          <div className="relative">
            <Input 
              type="text"
              placeholder="Kërko..."
              className="w-64 h-10 pr-10"
              autoFocus
            />
            <button 
              className="absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:bg-gray-100 rounded"
              onClick={() => setShowSearch(false)}
            >
              <X className="w-4 h-4 text-gray-400" />
            </button>
          </div>
        ) : (
          <button 
            className="p-2 hover:bg-gray-100 rounded-lg"
            onClick={() => setShowSearch(true)}
          >
            <Search className="w-5 h-5 text-gray-500" />
          </button>
        )}

        {/* Notifications */}
        <button className="p-2 hover:bg-gray-100 rounded-lg relative">
          <Bell className="w-5 h-5 text-gray-500" />
          {notifications > 0 && (
            <span 
              className="absolute top-1 right-1 w-4 h-4 text-white text-xs rounded-full flex items-center justify-center"
              style={{ background: '#dc2313' }}
            >
              {notifications}
            </span>
          )}
        </button>

        {/* User */}
        <div className="flex items-center gap-3 pl-3 border-l border-gray-200">
          <div 
            className="w-9 h-9 rounded-full flex items-center justify-center text-sm font-semibold"
            style={{ background: 'var(--gradient-primary)', color: 'var(--accent-text)' }}
          >
            {getInitials()}
          </div>
          <div className="hidden sm:block">
            <p className="text-sm font-medium" style={{ color: 'var(--text-primary)' }}>{getDisplayName()}</p>
            <p className="text-xs text-gray-500">Dispatcher</p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default DispatcherHeader;
